export default {
  promo_rate_plans: []
}
